import axios from 'axios'
import config from 'configs'

const http = axios.create({
  baseURL: config.external.base,
  // xsrfHeaderName: 'X-JIS-DEC-TOKEN',
  // withCredentials: true,
  crossDomain: true
})

const externalGet = function (url, config) {
  // var stampSign = /\?/.test(url) ? '&' : '?'
  // url += stampSign + new Date().getTime()
  return http.get(url, config)
}

export default {
  get: externalGet,
  baseUrl: config.external.base
}



// WEBPACK FOOTER //
// ./src/external.js